<template>
  <keep-alive>
    <router-view ref="routerView" :key="routerViewKey" />
  </keep-alive>
</template>
<script>
import { EafTenantApi } from '@wiz-api/eaf-tenant-management'
import { EafProfileApi } from '@wiz-api/account'
import axios from 'axios'
import { forIn, cloneDeep } from 'lodash'

export default {
  name: 'layout-fullscreen',
  data() {
    return {
      eafTenantApi: null,
      eafProfileApi: null,
      layoutLoaded: false,
      token: '',
      tenant: {
        id: '',
        name: '',
      },
    }
  },
  computed: {
    globalConfig() {
      return Wiz.globalSettings.globalConfig
    },
    routerViewKey() {
      return this.$route.fullPath
    },
  },
  methods: {
    refreshToken() {
      this.token = localStorage.getItem('authorization')
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      Wiz.AuthHooks.SetUserInfo({
        access_token: this.token,
        profile: userInfo.profile,
        tenantConfig: userInfo.tenantConfig,
      })
    },
    storageTokenChange(e) {
      if (e.key === 'authorization') {
        this.refreshToken()
      }
    },
    async getUserDetail() {
      const [err, res] = await this.eafProfileApi.getCurrentUserEafProfile()
      if (!err && res?.userInfo) {
        const userInfo = {}
        forIn(res.userInfo, (value, key) => {
          const undderscoreKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
          userInfo[undderscoreKey] = value
        })
        await Wiz.AuthHooks.SetUserInfo({
          access_token: this.token,
          profile: { tenantName: this.tenant.name, tenantid: this.tenant.id, ...userInfo },
        })
      }
    },
  },
  async created() {
    if (window.__POWERED_BY_QIANKUN__) {
      this.token = localStorage.getItem('authorization')
      this.currentLanguage = localStorage.getItem('lang') === 'en' ? 'en' : 'zh'
      window.addEventListener('storage', this.storageTokenChange)
    } else if (this.$route.query.token) {
      const query = this.$route.query
      this.token = query.token
      delete query.token
      this.$router.replace({
        path: this.$route.path,
        query,
        params: this.$route.params,
      })
    } else {
      this.token = Wiz.AuthHooks.GetToken()
    }

    axios.defaults.headers.common.Authorization = `Bearer ${this.token}`
    this.tenant.id = JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || ''
    this.$i18n.locale = this.currentLanguage
    // this.token = Wiz.AuthHooks.GetToken()
    console.warn(this.token)
    if (!this.token) {
      await Wiz.AuthHooks.SetUserInfo(null)
      this.layoutLoaded = true
      return
    }
    await Wiz.AuthHooks.SetUserInfo({
      access_token: this.token,
    })

    this.eafTenantApi = new EafTenantApi()
    this.eafProfileApi = new EafProfileApi()

    await this.getUserDetail()
    this.layoutLoaded = true
    this.$nextTick(() => {
      app.fullScreenCacheInstance = this.$refs.routerView.$vnode.parent.componentInstance
    })
  },
  mounted() {
    const appDom = document.getElementById('app')
    console.log(appDom, 'appDom-11')
    if (appDom) {
      appDom.classList.add('light')
    }
    // 获取主题配置
    const themeConfig = Wiz.globalSettings.layout.config
    let currentTheme = 'darkBlue'
    if (themeConfig) {
      currentTheme = !_.isNil(themeConfig.defaultTheme) ? themeConfig.defaultTheme : ''
    }
    this.$store.dispatch('System/currentTheme', currentTheme)
    document.getElementsByTagName('body')[0].classList.add(currentTheme)
    if (!window.__POWERED_BY_QIANKUN__) {
      // 非低代码
      return
    }
    const appMainMicroi = document.getElementsByClassName('app-main-microi')
    const microiService = document.getElementById('MicroiService')
    // 添加icon start
    const body = document.getElementsByTagName('body')[0]
    const head = document.getElementsByTagName('head')[0]
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = '/lib/iconfont/iconfont.css'
    head.firstChild.appendChild(link)
    console.log(head, 'head')
    const playerPlugins = ['Player.js', 'PlayerUtils.js', 'qwebchannel.js']
    _.forEach(playerPlugins, (name) => {
      const script = document.createElement('script')
      script.src = `/lib/player/${name}`
      body.firstChild.appendChild(script)
    })
    const videoPlugins = ['h5player.min.js']
    _.forEach(videoPlugins, (name) => {
      const script = document.createElement('script')
      script.src = `/lib/video/HKh5Player/${name}`
      body.firstChild.appendChild(script)
    })
    // konva
    const konvaPlugins = ['konva.min.js']
    _.forEach(konvaPlugins, (name) => {
      const script = document.createElement('script')
      script.src = `/static/konva/${name}`
      body.firstChild.appendChild(script)
    })
    // 高德天气查询接口依赖文件
    if (Wiz.globalSettings.globalConfig.amapSecurityJsCode) {
      wiz._AMapSecurityConfig = {
        securityJsCode: Wiz.globalSettings.globalConfig.amapSecurityJsCode,
      }
      const script = document.createElement('script')
      script.src = '/lib/webapi.amap.js'
      body.firstChild.appendChild(script)
      console.warn(wiz, '_AMapSecurityConfig')
    }
    // 添加icon end
    if (
      this.$route.query.ShowClassicTop === 'false' &&
      this.$route.query.ShowClassicLeft === 'false' &&
      microiService &&
      appMainMicroi
    ) {
      microiService?.classList?.add('full-screen')
      appMainMicroi[0]?.classList?.add('full-screen')
      return
    }
    if (microiService && appMainMicroi) {
      microiService?.classList?.remove('full-screen')
      appMainMicroi[0]?.classList?.remove('full-screen')
    }
  },
  destoryed() {},
}
</script>
